/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StatesService {
    /**
     * List all states
     * Get a paginated list of states, optionally filtered by country
     * @param countryId Filter by country ID
     * @param search Search by state name
     * @param perPage Items per page
     * @returns any List of states
     * @throws ApiError
     */
    public static e4A9654897D4E158D47Dbb723A3826(
        countryId?: number,
        search?: string,
        perPage: number = 15,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/states',
            query: {
                'country_id': countryId,
                'search': search,
                'per_page': perPage,
            },
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Get a specific state
     * Retrieve details of a specific state with its cities
     * @param id State ID
     * @returns any State details
     * @throws ApiError
     */
    public static c3Eb441051Bbd63D9876F8611193Be6(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/states/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `State not found`,
            },
        });
    }
}
